module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/wygLFD/tc-custom/9781035864249.jpg?1737196545512",
      "alt": "This image is the cover for the book Popplestone & Spells"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Popplestone & Spells\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Colin was engrossed in a book in his cozy Auckland flat when he drifted off to sleep. Upon waking, he found himself in a sun-kissed field of swaying corn, completely disoriented. Two curious children offered to guide him to their father in the charming village of Popplestone. There, Colin encountered an eccentric cast of villagers, each with their own peculiarities and quirks. As Colin’s adventures unfold, filled with unexpected twists and surprises, you, the reader, are invited to join him on this journey by keeping a Green Journal. You’ll be immersed in every facet of the adventure, meeting the characters through Colin’s eyes. Enchanted spells permeate the air, seemingly connected to a mysterious figure residing in the nearby woods. The story’s conclusion will catch you off guard with its unconventional and astonishing revelation. Brace yourself for an ending you never saw coming!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Colin Stonelake\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Colin Stonelake was born in Bargoed, a small town in South Wales, UK in 1960. After leaving college, he went on to complete his nurse training, emigrating to New Zealand in 2008. Colin maintains a strong family connection with his mother and sister. Since taking early retirement, Colin has gone on to develop new interests in creative arts. He is a strong advocate of fundraising for charities in Aotearoa.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0